module.exports = __webpack_public_path__ + "static/awards-b4e31bcd389ceabd51f36fa820baeb39.jpg";